export const BREAKPOINT_VALUES = {
  XXXL: 1919,
  XXL: 1599,
  XL: 1249,
  LG: 899,
  MD: 599,
  SM: 449,
  XS: 0,
}

export const BREAKPOINTS = {
  XXXL: `${BREAKPOINT_VALUES.XXXL}px`,
  XXL: `${BREAKPOINT_VALUES.XXL}px`,
  XL: `${BREAKPOINT_VALUES.XL}px`,
  LG: `${BREAKPOINT_VALUES.LG}px`,
  MD: `${BREAKPOINT_VALUES.MD}px`,
  SM: `${BREAKPOINT_VALUES.SM}px`,
  XS: `${BREAKPOINT_VALUES.XS}px`,
}

export type BreakPointKeys = keyof typeof BREAKPOINT_VALUES
export type Breakpoints = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'xxxl'

export const FONT_WEIGHTS = {
  LIGHT: 380,
  REGULAR: 400,
  MEDIUM: 500,
  HEAVY: 570,
  SEMI_BOLD: 600,
  STRONG: 670,
  BOLD: 700,
  EXTRA_BOLD: 800,
}

export const STYLE_UNITS = {
  SPACING_MULTIPLIER: 8,
  BORDER_RADIUS_MULTIPLIER: 4,
}

/**
 * Global UI density factor. The whole design system (type scale, MUI spacing,
 * and border radius) is multiplied by this, so the platform renders at the
 * scale it used to show at ~80% browser zoom — without any zoom/transform hack.
 */
export const UI_SCALE = 1

/** Scales a base pixel value by {@link UI_SCALE} and returns a px string. */
export const scaledPx = (value: number) => `${value * UI_SCALE}px`
